export const tiposConteudo = Object.freeze({
    PROTOCOLO: 1,
    FLUXOGRAMA: 2,
    DIRETRIZ: 3,
    DOCUMENTO: 4,
    OUTROS: 5,
});

export const tiposConteudoLabel = {
    [tiposConteudo.PROTOCOLO]: 'Protocolo',
    [tiposConteudo.FLUXOGRAMA]: 'Fluxograma',
    [tiposConteudo.DIRETRIZ]: 'Diretriz',
    [tiposConteudo.DOCUMENTO]: 'Documento',
    [tiposConteudo.OUTROS]: 'Outros',
};
